import { Routes, Route } from "react-router-dom";
import { ErrorBoundary } from "./components/index.js";
import { LandingPage } from "./routes/LandingPage.js";
import { LoginPage } from "./routes/LoginPage.js";
import { RegisterPage } from "./routes/RegisterPage.js";
import { JoinPage } from "./routes/JoinPage.js";
import { PlayPage } from "./routes/PlayPage.js";
import { AdminQuizzesPage } from "./routes/AdminQuizzesPage.js";
import { AdminQuizEditorPage } from "./routes/AdminQuizEditorPage.js";
import { HostLobbyPage } from "./routes/HostLobbyPage.js";
import { ReportsListPage } from "./routes/ReportsListPage.js";
import { ReportDetailPage } from "./routes/ReportDetailPage.js";
import { NotFoundPage } from "./routes/NotFoundPage.js";
import { RequireAuth } from "./components/RequireAuth.js";

export function App() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/join" element={<JoinPage />} />
        <Route path="/join/:pin" element={<JoinPage />} />
        <Route path="/play/:sessionId" element={<PlayPage />} />
        <Route
          path="/admin/quizzes"
          element={
            <RequireAuth>
              <AdminQuizzesPage />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/quizzes/:quizId/edit"
          element={
            <RequireAuth>
              <AdminQuizEditorPage />
            </RequireAuth>
          }
        />
        <Route
          path="/host/:sessionId"
          element={
            <RequireAuth>
              <HostLobbyPage />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/reports"
          element={
            <RequireAuth>
              <ReportsListPage />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/reports/:sessionId"
          element={
            <RequireAuth>
              <ReportDetailPage />
            </RequireAuth>
          }
        />
        <Route path="/" element={<LandingPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </ErrorBoundary>
  );
}
